import { FinancialDocumentDetailIncludeQuery } from "@common/schemas/financialDocument/financial-document-detail-include.schema";

export const transactionsImporterDetailIncludes: FinancialDocumentDetailIncludeQuery =
    {
        includeAll: false,
        includeAccountInfoExtraction: true,
    };

export const accrualImporterDetailIncludes: FinancialDocumentDetailIncludeQuery =
    {
        includeAll: false,
        includeAccrualExtractions: true,
    };
